<script setup lang="ts">
import WidgetContainer from "@/components/EditView/widgets/WidgetContainer.vue";
import {WidgetProps} from "@/utils/presenters/interfaces.ts";
import FieldWidgetUtil from "@/utils/editView/widgets/FieldWidgetUtil.ts";
import ErrorTooltip from "@/components/EditView/ErrorTooltip.vue";
import {ref} from "vue";
import {QInput} from "quasar";
import {focusAndSelectInput} from "@/utils/common/NamaVueWidget.ts";

const props = defineProps<WidgetProps>();
const fieldId = props.field.id!;
const fieldUtil = new FieldWidgetUtil(props.presenter, props.fieldMetaData);

const color = fieldUtil.formattedValue();
const input = ref<QInput>()

function focus() {
  focusAndSelectInput(input);
}

function canReceiveFocus() {
  return !fieldUtil.isFieldDisabled(props.forceEnableField);
}

defineExpose({focus, canReceiveFocus})
</script>

<template>
  <WidgetContainer
    :field="field"
    :entityType="presenter.entityType"
    :isSpanned="isSpanned" :isFieldDisabled="fieldUtil.isFieldDisabled(forceEnableField)"
    :isFieldRequired="fieldUtil.isFieldRequired()" :doNotApplyThemeLayouts="doNotApplyThemeLayouts"
    :isInsideComposite="isInsideComposite">
    <template v-slot:widget="{ showAsPassword, doNotGoToNextWithEnter }">
      <q-input outlined dense hide-bottom-space ref="input"
               :readonly="fieldUtil.isFieldDisabled(forceEnableField)"
               :id="fieldId"
               autocomplete="off"
               :type="showAsPassword ? 'password' : 'text'"
               :error="!!props.presenter.fetchFieldErrorMsg(fieldId)"
               class="nama-customize-dense-input nama-focused-input"
               :class="{'nama-field-input-disabled':fieldUtil.isFieldDisabled(forceEnableField),'nama-field-input':!fieldUtil.isFieldDisabled(forceEnableField)}"
               input-class="nama-input-class !tw-pl-0"
               :model-value="color" @update:model-value="fieldUtil.onPartialUserInput" @focus="fieldUtil.onFocus" @blur="fieldUtil.onBlur"
               @keydown.enter="(e)=>{ if (!doNotGoToNextWithEnter) $emit('navigateToNext',{keyboardEvent:e}) }">
        <template v-slot:prepend>
          <div class="tw-pl-2 tw-flex">
            <q-avatar class="nama-avatar-hover tw-cursor-pointer tw-size-7">
              <q-icon name="colorize" class="tw-cursor-pointer tw-text-[20px] tw-text-iconColor-light  dark:tw-text-iconColor-dark">
                <q-popup-proxy class="tw-bg-transparent" transition-show="scale" transition-hide="scale">
                  <q-color :model-value="color" @update:model-value="fieldUtil.onPartialUserInput" @change="fieldUtil.onUserInputFinished"
                           :readonly="fieldUtil.isFieldDisabled(forceEnableField)"
                           class="tw-text-namaBlack tw-bg-namaBackground-deep-light dark:tw-text-white dark:tw-bg-namaBackground-dim-dark"/>
                </q-popup-proxy>
              </q-icon>
            </q-avatar>
          </div>
        </template>
        <template v-slot:append>
          <q-avatar class="tw-cursor-pointer nama-avatar-hover">
            <q-icon name="circle"
                    class="tw-cursor-pointer tw-text-[18px] tw-rounded-full tw-ring-1 tw-ring-namaFontColor-light dark:tw-ring-namaFontColor-dark"
                    :class="{'tw-text-iconColor-light dark:tw-text-iconColor-dark' : !color}" :style="{color}">
              <q-popup-proxy class="tw-bg-transparent" transition-show="scale" transition-hide="scale">
                <q-color :model-value="color" @update:model-value="fieldUtil.onPartialUserInput" @change="fieldUtil.onUserInputFinished"
                         class="tw-text-namaBlack tw-bg-namaBackground-deep-light dark:tw-text-white dark:tw-bg-namaBackground-dim-dark"/>
              </q-popup-proxy>
            </q-icon>
          </q-avatar>
        </template>
        <ErrorTooltip v-if="presenter.fetchFieldErrorMsg(fieldId)" :error-msg="presenter.fetchFieldErrorMsg(fieldId)"/>
      </q-input>
    </template>
  </WidgetContainer>
</template>

<style>

</style>
